var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasPermission('PartnerAdd'))?_c('div',{staticClass:"add-reseller"},[_c('h2',[_vm._v(_vm._s(_vm.$t('Add new reseller')))]),_c('add-partner',{ref:"reseller",attrs:{"partner-id":_vm.partnerId,"zoho-id":_vm.zohoId,"partner-type":"reseller"},on:{"created":function($event){return _vm.$emit('created')}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }